import { j as b } from "../../jsx-runtime.BREq8dyb.js";
import { u as g, C as S } from "../../sortable.esm.jwEM6DG5.js";
import { styled as h, Accordion as x, useThemeProps as j } from "@mui/joy";
import { forwardRef as A, useMemo as D } from "react";
const n = "DqSortableAccordion", R = h(x, {
  name: n,
  slot: "root"
})(), E = A((i, o) => {
  const {
    children: a,
    id: c,
    ...l
  } = j({
    name: n,
    props: i
  }), {
    isDragging: m,
    items: s,
    newIndex: r,
    setNodeRef: f,
    transform: e,
    transition: d
  } = g({
    id: c
  }), p = {
    transform: S.Transform.toString(e ? {
      ...e,
      scaleY: 1
    } : null),
    transition: d,
    zIndex: m ? 2 : 1
  }, u = D(() => Object.assign(
    {},
    // NOTE: To let List(Item|ItemButton) know when to apply margin(Inline|Block)Start 🤷‍♂️
    Object.fromEntries([r === 0 && "data-first-child", r === s.length - 1 && "data-last-child"].filter(Boolean).map((t) => [t, ""]))
  ), [s.length, r]);
  return /* @__PURE__ */ b.jsx(R, { ref: (t) => {
    f(t), typeof o == "function" ? o(t) : o && (o.current = t);
  }, style: p, ...u, ...l, children: a });
});
export {
  E as default
};
//# sourceMappingURL=DqSortableAccordion.js.map
